import { render, staticRenderFns } from "./IconTrophy.vue?vue&type=template&id=79d6e5d2&scoped=true"
import script from "./IconTrophy.vue?vue&type=script&lang=js"
export * from "./IconTrophy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d6e5d2",
  null
  
)

export default component.exports